module.exports = __webpack_public_path__ + "a9576c4cce8d3624e19c6c881dfabcaf.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-global-search/sp-global-search.html
// module id = 1053
// module chunks = 0